// extracted by mini-css-extract-plugin
module.exports = {"rows":"Circles_rows__1HTuF","rows_bottom":"Circles_rows_bottom__38NIc","rows_right":"Circles_rows_right__1BFxe","row":"Circles_row__2zuKG","circle":"Circles_circle__1-Sa5"};